<div class="confirmation-dialog min-h-[200px]">
  <h2 mat-dialog-title i18n>{{data.title}}</h2>
  @if (data.message) {
  <mat-dialog-content>
    <p i18n class="whitespace-pre-line">{{data.message}}</p>
    <br />
    <p i18n class="whitespace-pre-line">{{data.subMessage}}</p>
  </mat-dialog-content>
  }
  <mat-dialog-actions class="flex !justify-end">
    <button id="cancel_button" mat-button (click)="handleOnClick(false)" i18n>{{data.cancel}} </button>
    <button id="confirm_button" mat-button (click)="handleOnClick(true)" i18n>{{data.confirm}}</button>
  </mat-dialog-actions>
</div>